const sendBotMessageToAgent = async ({ content }: { content: string }) => {
  // [live-chat-split-change]
  // 异步加载live chat逻辑，避免阻塞首屏渲染
  import('@/utils/liveChatSDK').then((module) => {
    const { safeCallLiveChatSDK } = module;
    safeCallLiveChatSDK((sdk) => {
      sdk?.sendBotMessageToAgent?.({ content });
    });
  });
  // const curPos = addUserMsg({
  //   from: 'user',
  //   type: 'Msg',
  //   data: {
  //     content: content,
  //     // loading: true
  //     requesting: true
  //   }
  // });

  // // 未成功输入
  // if (typeof curPos !== 'number') {
  //   return;
  // }

  // // 如果会话已结束
  // if (agentStore.agentEndedReason) {
  //   // 回显agent离开文案
  //   reviewChatEndText();
  //   agentStore.UPDATE_AGENT_DATA_ITEM({
  //     loading: false,
  //     error: true,
  //     requesting: false
  //   }, curPos);
  //   return;
  // }
  // // in Queue 不发请求
  // if (agentStore.position) {
  //   agentStore.UPDATE_AGENT_DATA_ITEM({
  //     loading: false,
  //     requesting: false
  //   }, curPos);
  // } else {
  //   const {code: resCode} = await postChatMsg({ text: content });
  //   if (resCode === GetMsgResCode.SUCCESS) {
  //     agentStore.UPDATE_AGENT_DATA_ITEM({
  //       loading: false,
  //       requesting: false
  //     }, curPos);
  //   } else {
  //     agentStore.UPDATE_AGENT_DATA_ITEM({
  //       loading: false,
  //       error: true,
  //       requesting: false
  //     }, curPos);
  //   }
  // }
};

export default sendBotMessageToAgent;
